import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { Button } from 'atoms/buttons/Button';
import { FOOTBALL_MARKET_WHEEL } from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

type Props = {
  nbTickets?: number;
  children?: React.ReactNode;
};

export const SecondaryOrTickets = ({ nbTickets = 2, children }: Props) => {
  const { sport } = useSportContext();
  const {
    flags: {
      marketDailyWheel = { baseball: false, football: false, nba: false },
    },
  } = useFeatureFlags();
  if (!marketDailyWheel[sport.toLowerCase()]) {
    return children;
  }

  return (
    <Button
      to={generatePath(FOOTBALL_MARKET_WHEEL, { sport })}
      color="transparent"
      fullWidth
      size="medium"
    >
      <FormattedMessage
        id="Wheel.Cta.GoSpin"
        defaultMessage="{nbTickets, plural, one {+1 Wheel Ticket!} other {+# Wheel Tickets!}}"
        values={{
          nbTickets,
        }}
      />
    </Button>
  );
};
